import React from "react" 
import ImageMeta from "../components/ImageMeta"
import Layout from "../components/layout"
import { SharedStateProvider } from "../components/SharedState/PageSharedState"
import { Link, graphql } from "gatsby"
import SEO from "../components/seo"


import Button from '@bit/azheng.joshua-tree.button';
import CollapseRow from "../components/CollapseRow"

function createHtml(html) {
  return { __html: html }
}
var showdown = require("showdown")
const converter = new showdown.Converter()

const DentalImplantsFAQPage = (props) => {

  const post = props.data.allUniquePagesJson.nodes[0];
  
  return (
  <SharedStateProvider>
    <Layout>
    <SEO title={post.metaTitle} description={post.metaDescription} />
      <Button buttonText="BACK" goBack />
      <div className="joshua-tree-content">
        <div className="columns top-section text-section is-mobile white-back" style={{ paddingBottom: "0" }}>
          <div className="column is-6"></div>
          <div className="column is-12">
            <div>
              <h1>{post.heading}</h1>
            </div>
          </div>
        </div>

        <section className="body-sections section collapse-rows" style={{ paddingTop: "34px" }}>
          {post.collapseRows.map((row, i) => 
                  <CollapseRow
                  key={row.collapseRow.heading}
                  isOpen={i === 0}
                  heading={<h5>{row.collapseRow.heading}</h5>}
                  paragraphs={<div dangerouslySetInnerHTML={createHtml(
                    converter.makeHtml(row.collapseRow.text)
                  )}></div>}
                />  
          )}
        </section>
      </div>
    </Layout>
  </SharedStateProvider>
)}

export const pageQuery = graphql`
query dentalImplantsFAQPage ($loneUrl: String!)  {
  allUniquePagesJson(filter: {title: {eq: $loneUrl}}) {
    nodes {
      title
      heading
      metaTitle
      metaDescription
      collapseRows {
        collapseRow {
          heading
          text
        }
      }
    }
  }
}

`

export default DentalImplantsFAQPage
